"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validationMessages = void 0;
exports.validationMessages = {
    alphanumeric: (maxCharacters) => `Only latin alphanumeric characters are allowed, maximum ${maxCharacters} characters`,
    format: (format) => `Must match format ${format}`,
    countryCode: (sample) => `Must be a country code e.g. ${sample}`,
};
